import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import LandingPage from '../pages/Landing/LandingPage';
import Login from '../pages/Login/Login';
import PrivateRoute from './PrivateRoute';
import ErrorPage from '../components/ErrorPage/ErrorPage';
import ScenarioLibrary from '../pages/ScenarioLibrary/ScenarioLibrary';
import ScenarioCreation from '../pages/ScenarioCreation/ScenarioCreation';
import ScenarioResult from '../pages/ScenarioResult/ScenarioResult';
import DocsFrame from '../components/Docs/DocsFrame';

const AppRouter: React.FC = () => {
  const basename = import.meta.env.VITE_APP_BASE_URL_FRONTEND || '';

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />

        <Route path="/login" element={<Login />} />

        <Route path="/landing" element={<PrivateRoute component={LandingPage} layout={false} />} />

        <Route path="/scenario-creation" element={<PrivateRoute component={ScenarioCreation} layout={true} />} />
        <Route path="/scenario-library" element={<PrivateRoute component={ScenarioLibrary} layout={true} />} />

        <Route path="/scenario-result" element={<PrivateRoute component={ScenarioResult} layout={true} />} />
        <Route path="/documentation" element={<PrivateRoute component={DocsFrame} layout={true} />} />

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
